import { render, staticRenderFns } from "./ChangeDetailsTable.vue?vue&type=template&id=d517b7d6&scoped=true"
import script from "./ChangeDetailsTable.vue?vue&type=script&lang=js"
export * from "./ChangeDetailsTable.vue?vue&type=script&lang=js"
import style0 from "./ChangeDetailsTable.vue?vue&type=style&index=0&id=d517b7d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d517b7d6",
  null
  
)

export default component.exports